export enum RoleType {
    Admin = 'Admin',
    SecuritySupervisor = 'Security Supervisor',
    SuperAdmin = 'Super Admin',
    User = 'User'

}
export enum ComponentName {
  Users = 'Users',
  Offices = 'Offices',
  Inward = 'Inward',
  Cities = 'Cities',
  Outward = 'Outward',
  OutwardL1Approver = 'OutwardL1Approver',
  OutwardL2Approver = 'OutwardL2Approver',
  OutwardSupervisor = 'OutwardSupervisor',
  AuditTrail = 'AuditTrail',
  CommonAuditTrail = 'CommonAuditTrail',
  AuditMain="AuditMain",
  AuditConfiguration = "AuditConfiguration"
}
export enum ModalSize{
    Large = 'modal-lg',
    Small = 'modal-sm',
    XLarge='modal-xl',
    Medium='modal-md' 
}
export enum OnStatus{
    Active='Active',
    Inactive='Inactive'
}
